<template>
  <div style="background: #f7f8fa">
    <my-head></my-head>
    <div class="valuation-form minH">
      <div class="crumbs">
        首页 > 知产质押融资 >
        <span style="color: #1d2129">估值资料清单</span>
      </div>

                                            <div class="valuation_form">
                   <div class="form-title">知识产权质押融资估值资料清单</div>
          <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
             <!-- 1. 企业全称 -->
               <el-form-item label="企业全称 (营业执照上的名称)*" prop="qyqc">
                 <el-input v-model="form.qyqc" placeholder="请输入" style="width: 100%;"></el-input>
      </el-form-item>

                           <!-- 2. 企业联系人和联系方式 -->
        <el-row :gutter="20">
                       <el-col :span="12">
             <el-form-item label="企业联系人*" prop="qylxr">
               <el-input v-model="form.qylxr" placeholder="请输入联系人名称" style="width: 100%;"></el-input>
             </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="联系方式*" prop="lxfs">
               <el-input v-model="form.lxfs" placeholder="请输入联系人联系方式" style="width: 100%;"></el-input>
             </el-form-item>
           </el-col>
        </el-row>

             <!-- 4. 拟融资规模 -->
               <el-form-item label="拟融资规模 (单位:万元)*" prop="nrzgm">
                 <el-input v-model="form.nrzgm" placeholder="请输入" style="width: 100%;">
          <template slot="append">万</template>
        </el-input>
      </el-form-item>

             <!-- 银行信息字段（仅当从个人中心跳转时显示） -->
             <div v-if="showBankInfo">
               <el-form-item label="贷款行全称" prop="dkhqc">
                 <el-input v-model="form.dkhqc" placeholder="请输入" style="width: 100%;"></el-input>
               </el-form-item>

               <el-row :gutter="20">
                 <el-col :span="12">
                   <el-form-item label="客户经理姓名" prop="khjlxm">
                     <el-input v-model="form.khjlxm" placeholder="请输入客户经理姓名" style="width: 100%;"></el-input>
                   </el-form-item>
                 </el-col>
                 <el-col :span="12">
                   <el-form-item label="客户经理联系方式" prop="khjllxfs">
                     <el-input v-model="form.khjllxfs" placeholder="请输入客户经理联系方式" style="width: 100%;"></el-input>
                   </el-form-item>
                 </el-col>
               </el-row>
             </div>

             <!-- 5. 企业简介 -->
               <el-form-item label="企业简介*" prop="qyjj">
                 <el-input 
           type="textarea" 
           v-model="form.qyjj" 
           placeholder="请输入"
           :rows="4"
           style="width: 100%;">
        </el-input>
      </el-form-item>

                           <!-- 6. 专利明细列表 -->
                 <el-form-item label="企业拟用于本次事宜的专利明细列表 (已授权,剩余寿命大于等于5年,填写1-5项)*" prop="zlml">
          <div class="patent-table">
            <el-table :data="form.zlml" border style="width: 100%">
             <el-table-column prop="serial" label="序号" width="80" align="center"></el-table-column>
             <el-table-column prop="name" label="专利名称" min-width="300">
               <template slot-scope="scope">
                 <el-input v-model="scope.row.name" placeholder="请输入专利名称"></el-input>
               </template>
             </el-table-column>
             <el-table-column prop="type" label="专利类型" width="120">
               <template slot-scope="scope">
                 <el-select v-model="scope.row.type" placeholder="请选择" style="width: 100%">
                   <el-option label="发明" value="发明"></el-option>
                   <el-option label="实用新型" value="实用新型"></el-option>
                   <el-option label="外观设计" value="外观设计"></el-option>
                 </el-select>
               </template>
             </el-table-column>
             <el-table-column prop="applicationNumber" label="申请号" width="150">
               <template slot-scope="scope">
                 <el-input v-model="scope.row.applicationNumber" placeholder="请输入"></el-input>
               </template>
             </el-table-column>
                                                       <el-table-column label="操作" width="150" align="center">
                 <template slot-scope="scope">
                   <el-button size="small" type="text" @click="editPatent(scope.$index)">修改</el-button>
                   <el-button size="small" type="text" @click="deletePatent(scope.$index)">删除</el-button>
                 </template>
               </el-table-column>
           </el-table>
                                               <div class="add-patent-btn">
               <el-button size="small" type="primary" @click="addPatent" :disabled="form.zlml.length >= 5">
                 添加一行专利
               </el-button>
               <span class="patent-tip">最多可添加5项专利信息</span>
             </div>
         </div>
       </el-form-item>

             <!-- 7. 无形资产与企业产品/服务的对应关系 -->
               <el-form-item label="拟估值的无形资产与企业产品/服务的对应关系 (简要说明,300字以内)*" prop="wxcps">
                 <el-input 
           type="textarea" 
           v-model="form.wxcps" 
           placeholder="请输入"
           :rows="4"
           maxlength="300"
           show-word-limit
           style="width: 100%;">
        </el-input>
      </el-form-item>

                           <!-- 8. 历史财务信息 -->
                 <el-form-item label="历史财务信息 (基准日前三年及最新一期)（ 万元）" prop="historicalYears">
          <div class="financial-table">
                         <el-table :data="form.lscwxx" border style="width: 100%">
                <el-table-column prop="name" label="" min-width="120"></el-table-column>
             <el-table-column 
               v-for="(year, yearIndex) in form.historicalYears" 
               :key="yearIndex"
               min-width="120">
               <template slot="header">
                 <input 
                   v-model="form.historicalYears[yearIndex]" 
                   :placeholder="`年份${yearIndex + 1}`"
                   type="text"
                   class="header-year-input"
                   @click.stop
                   @mousedown.stop
                   @focus.stop>
               </template>
               <template slot-scope="scope">
                 <el-input v-model="scope.row.values[yearIndex]" placeholder="请输入">
                   <template slot="append">万</template>
                 </el-input>
               </template>
             </el-table-column>
                                                                                                           <el-table-column label="操作" min-width="80" align="center">
                  <template slot-scope="scope">
                    <el-button size="small" type="text" @click="clearRow(scope.$index)">清除</el-button>
                  </template>
                </el-table-column>
           </el-table>
         </div>
       </el-form-item>

                           <!-- 9. 未来五年财务预测 -->
                 <el-form-item label="未来五年的财务预测情况（万元）" prop="futureYears">
          <div class="financial-table">
                         <el-table :data="form.wlnwcw" border style="width: 100%">
                <el-table-column prop="name" label="" min-width="120"></el-table-column>
             <el-table-column 
               v-for="(year, yearIndex) in form.futureYears" 
               :key="yearIndex"
               min-width="120">
               <template slot="header">
                 <input 
                   v-model="form.futureYears[yearIndex]" 
                   :placeholder="`年份${yearIndex + 1}`"
                   type="text"
                   class="header-year-input"
                   @click.stop
                   @mousedown.stop
                   @focus.stop>
               </template>
               <template slot-scope="scope">
                 <el-input v-model="scope.row.values[yearIndex]" placeholder="请输入">
                   <template slot="append">万</template>
                 </el-input>
               </template>
             </el-table-column>
                                                                                                           <el-table-column label="操作" min-width="80" align="center">
                  <template slot-scope="scope">
                    <el-button size="small" type="text" @click="clearFutureRow(scope.$index)">清除</el-button>
                  </template>
                </el-table-column>
           </el-table>
         </div>
       </el-form-item>

                           <!-- 表单操作按钮 -->
        <div class="buttons flex-center">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
         </el-form>
       </div>
   </div>
   <my-footer></my-footer>
 </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { postRequest, getRequest } from "../../api/api";

export default {
  name: 'ValuationForm',
  components: { MyHead, MyFooter },
  data() {
    return {
      lastMonth: this.getLastMonth(),
      shouQuanData: { bank: null }, // 授权中心数据，包含银行认证信息
      hasBankInfoInEdit: false, // 编辑模式下是否有银行信息
      form: {
        qyqc: '', // 企业全称
        qylxr: '', // 企业联系人
        lxfs: '', // 联系方式
        nrzgm: '', // 拟融资规模
        qyjj: '', // 企业简介
        wxcps: '', // 无形资产与企业产品/服务的对应关系
        // 银行信息字段（仅当从个人中心跳转时显示）
        dkhqc: '', // 贷款行全称
        khjlxm: '', // 客户经理姓名
        khjllxfs: '', // 客户经理联系方式
        historicalYears: ['', '', '', '', ''], // 历史财务信息5个年份输入框
        futureYears: ['', '', '', '', ''], // 未来五年财务预测5个年份输入框
        zlml: [ // 专利明细列表
          {
            serial: 1,
            name: '',
            type: '',
            applicationNumber: ''
          }
        ],
        lscwxx: [ // 历史财务信息
          {
            name: '营业收入',
            values: ['', '', '', '', ''] // 对应5个年份的数值
          },
          {
            name: '研发投入',
            values: ['', '', '', '', '']
          },
          {
            name: '净利润',
            values: ['', '', '', '', '']
          }
        ],
        wlnwcw: [ // 未来五年财务预测
          {
            name: '营业收入',
            values: ['', '', '', '', ''] // 对应5个年份的数值
          },
          {
            name: '研发投入',
            values: ['', '', '', '', '']
          },
          {
            name: '净利润',
            values: ['', '', '', '', '']
          }
        ]
      },
            rules: {
        qyqc: [
          { required: true, message: '请输入企业全称', trigger: 'blur' }
        ],
        qylxr: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' }
        ],
        lxfs: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        nrzgm: [
          { required: true, message: '请输入拟融资规模', trigger: 'blur' }
        ],
        qyjj: [
          { required: true, message: '请输入企业简介', trigger: 'blur' }
        ],
                 wxcps: [
           { required: true, message: '请输入无形资产与企业产品/服务的对应关系', trigger: 'blur' }
         ],
          zlml: [
            { 
              type: 'array', 
              validator: (rule, value, callback) => {
                if (value.length === 0) {
                  callback(new Error('请至少添加一项专利信息'));
                } else {
                  const invalidPatents = value.filter(patent => !patent.name || !patent.type || !patent.applicationNumber);
                  if (invalidPatents.length > 0) {
                    callback(new Error('请完善专利信息'));
                  } else {
                    callback();
                  }
                }
              }, 
              trigger: 'change' 
            }
          ]
        }
    }
  },
  computed: {
    // 判断是否显示银行信息字段
    showBankInfo() {
      // 情况1：当前用户已完成银行认证（无论从哪里进入 /valuationform）
      const isBankCertified = this.shouQuanData.bank && this.shouQuanData.bank.status === 1;
      // 情况2：编辑模式下有银行信息
      return isBankCertified || this.hasBankInfoInEdit;
    }
  },
  watch: {
    // 监听 showBankInfo 变化，动态添加验证规则
    showBankInfo(newVal) {
      if (newVal) {
        // 如果显示银行信息字段，添加验证规则
        this.rules.dkhqc = [
          { required: true, message: '请输入贷款行全称', trigger: 'blur' }
        ];
        this.rules.khjlxm = [
          { required: true, message: '请输入客户经理姓名', trigger: 'blur' }
        ];
        this.rules.khjllxfs = [
          { required: true, message: '请输入客户经理联系方式', trigger: 'blur' }
        ];
      } else {
        // 如果不显示银行信息字段，移除验证规则
        delete this.rules.dkhqc;
        delete this.rules.khjlxm;
        delete this.rules.khjllxfs;
      }
    }
  },
  created() {
    // 获取授权中心信息（包含银行认证状态）
    this.getShouQuan();
    // 检查是否有编辑ID，如果有则加载数据
    if (this.$route.query.editId) {
      this.loadEditData(this.$route.query.editId);
    }
  },
  methods: {
    // 获取授权中心信息（包含银行认证状态）
    getShouQuan() {
      getRequest({ url: "/api/v1/transfer/transferMessage" }).then((res) => {
        if (res.errcode == 200) {
          this.shouQuanData = { bank: null, ...res.data };
        }
      });
    },
    // 加载编辑数据（用于重新提交）
    loadEditData(applicationId) {
      getRequest({
        url: `/api/v1/valuation-form/${applicationId}`
      }).then((res) => {
        if (res.errcode === 200 && res.data) {
          const data = res.data;
          
          // 填充基本信息
          this.form.qyqc = data.qyqc || '';
          this.form.qylxr = data.qylxr || '';
          this.form.lxfs = data.lxfs || '';
          this.form.nrzgm = data.nrzgm || '';
          this.form.qyjj = data.qyjj || '';
          this.form.wxcps = data.wxcps || '';
          
          // 填充银行信息（如果有）
          if (data.dkhqc || data.khjlxm || data.khjllxfs) {
            this.form.dkhqc = data.dkhqc || '';
            this.form.khjlxm = data.khjlxm || '';
            this.form.khjllxfs = data.khjllxfs || '';
            this.hasBankInfoInEdit = true;
            // 添加银行信息字段的验证规则
            this.rules.dkhqc = [
              { required: true, message: '请输入贷款行全称', trigger: 'blur' }
            ];
            this.rules.khjlxm = [
              { required: true, message: '请输入客户经理姓名', trigger: 'blur' }
            ];
            this.rules.khjllxfs = [
              { required: true, message: '请输入客户经理联系方式', trigger: 'blur' }
            ];
          }
          
          // 解析并填充专利明细列表
          if (data.zlml) {
            if (typeof data.zlml === 'string') {
              this.form.zlml = JSON.parse(data.zlml);
            } else {
              this.form.zlml = data.zlml;
            }
            // 确保每个专利都有serial
            this.form.zlml.forEach((patent, idx) => {
              if (!patent.serial) {
                patent.serial = idx + 1;
              }
            });
          }
          
          // 解析并填充历史财务信息
          if (data.lscwxx) {
            let lscwxxData;
            if (typeof data.lscwxx === 'string') {
              lscwxxData = JSON.parse(data.lscwxx);
            } else {
              lscwxxData = data.lscwxx;
            }
            
            if (lscwxxData && lscwxxData.years) {
              // 填充年份
              this.form.historicalYears = [...lscwxxData.years];
              // 确保有5个年份
              while (this.form.historicalYears.length < 5) {
                this.form.historicalYears.push('');
              }
            }
            
            if (lscwxxData && lscwxxData.indicators) {
              // 填充指标数据
              this.form.lscwxx = lscwxxData.indicators.map(indicator => {
                const values = [...indicator.values];
                // 确保每个指标都有5个值
                while (values.length < 5) {
                  values.push('');
                }
                return {
                  name: indicator.name,
                  values: values
                };
              });
            }
          }
          
          // 解析并填充未来五年财务预测
          if (data.wlnwcw) {
            let wlnwcwData;
            if (typeof data.wlnwcw === 'string') {
              wlnwcwData = JSON.parse(data.wlnwcw);
            } else {
              wlnwcwData = data.wlnwcw;
            }
            
            if (wlnwcwData && wlnwcwData.years) {
              // 填充年份
              this.form.futureYears = [...wlnwcwData.years];
              // 确保有5个年份
              while (this.form.futureYears.length < 5) {
                this.form.futureYears.push('');
              }
            }
            
            if (wlnwcwData && wlnwcwData.indicators) {
              // 填充指标数据
              this.form.wlnwcw = wlnwcwData.indicators.map(indicator => {
                const values = [...indicator.values];
                // 确保每个指标都有5个值
                while (values.length < 5) {
                  values.push('');
                }
                return {
                  name: indicator.name,
                  values: values
                };
              });
            }
          }
        }
      }).catch((error) => {
        console.error('加载编辑数据失败:', error);
        this.$message.error('加载数据失败，请重试');
      });
    },
    getLastMonth() {
      const now = new Date();
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      return lastMonth.getMonth() + 1 + '月';
    },
    addPatent() {
      if (this.form.zlml.length < 5) {
        this.form.zlml.push({
          serial: this.form.zlml.length + 1,
          name: '',
          type: '',
          applicationNumber: ''
        });
      }
    },
    deletePatent(index) {
      this.form.zlml.splice(index, 1);
      // 重新编号
      this.form.zlml.forEach((patent, idx) => {
        patent.serial = idx + 1;
      });
    },
    editPatent(index) {
      // 编辑专利信息的逻辑
      console.log('编辑专利:', index);
    },
    clearRow(index) {
      const row = this.form.lscwxx[index];
      row.values = ['', '', '', '', ''];
    },
    clearFutureRow(index) {
      const row = this.form.wlnwcw[index];
      row.values = ['', '', '', '', ''];
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 组织历史财务信息数据
          const historicalFinanceData = {
            years: this.form.historicalYears,
            indicators: this.form.lscwxx.map(indicator => ({
              name: indicator.name,
              values: indicator.values.map(val => val === '' ? null : parseFloat(val) || 0)
            }))
          };

          // 组织未来财务预测数据
          const futureFinanceData = {
            years: this.form.futureYears,
            indicators: this.form.wlnwcw.map(indicator => ({
              name: indicator.name,
              values: indicator.values.map(val => val === '' ? null : parseFloat(val) || 0)
            }))
          };

          // 构建提交数据
          // 默认状态：0-已提交；如果当前用户是银行认证用户，则直接进入 3-银行已通过
          const isBankCertified = this.shouQuanData.bank && this.shouQuanData.bank.status === 1;
          const submitData = {
            qyqc: this.form.qyqc,
            qylxr: this.form.qylxr,
            lxfs: this.form.lxfs,
            nrzgm: this.form.nrzgm,
            qyjj: this.form.qyjj,
            wxcps: this.form.wxcps,
            zlml: JSON.stringify(this.form.zlml),
            lscwxx: JSON.stringify(historicalFinanceData),
            wlnwcw: JSON.stringify(futureFinanceData),
            status: isBankCertified ? 3 : 0, // 银行认证用户：3-银行已通过；否则：0-已提交
          };

          // 如果有银行信息（从个人中心跳转或编辑模式），添加银行信息字段
          if (this.showBankInfo) {
            submitData.dkhqc = this.form.dkhqc;
            submitData.khjlxm = this.form.khjlxm;
            submitData.khjllxfs = this.form.khjllxfs;
          }

          // 调用 API 提交数据
          postRequest({
            url: "/api/v1/valuation-form",
            data: submitData,
          })
            .then((res) => {
              this.$message.success("提交成功");
              // 提交成功后跳转到个人中心
              setTimeout(() => {
                this.$router.push({
                  name: "my",
                  params: { tab: "质押融资" },
                });
              }, 1000);
            })
            .catch((error) => {
              console.error("提交失败:", error);
              this.$message.error("提交失败，请重试");
            });
        } else {
          this.$message.error('请完善必填信息！');
          return false;
        }
      });
    },
    cancel() {
      this.$confirm('确定要取消吗？未保存的数据将丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1);
      }).catch(() => {
        // 用户取消
      });
    }
  }
}
</script>

<style lang="scss">
.valuation-form {
  width: 80%;
  margin: 48px auto 60px;

  .crumbs {
    font-size: 14px;
    color: #86909c;
    margin-bottom: 20px;
  }



  .valuation_form {
    padding: 24px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e6eb;
    
                                       .form-title {
         font-size: 20px;
         font-weight: bold;
         color: #1d2129;
         line-height: 32px;
         text-align: left;
         margin-bottom: 32px;
         padding-bottom: 16px;
         border-bottom: 1px solid #e5e6eb;
       }

    .patent-table, .financial-table {
      margin-top: 10px;

      .add-patent-btn {
        margin-top: 15px;
        text-align: center;
        
        .patent-tip {
          margin-left: 15px;
          color: #999;
          font-size: 14px;
        }
      }
    }

         .el-form-item {
       margin-bottom: 25px;

       .el-form-item__label {
         font-weight: normal;
         color: #333;
       }
     }

         .el-table {
       // 表头样式
       .el-table__header-wrapper {
         .el-table__header {
           th {
             background-color: #f5f7fa !important;
             color: #333;
             font-weight: normal;
             padding: 8px 0;
             position: relative;
             overflow: visible !important;
             
             // 确保表头单元格可以交互
             &:hover {
               .header-year-input,
               .el-input .el-input__inner {
                 border-color: #c0c4cc;
               }
             }
           }
         }
         
         // 表头中的输入框样式（优先级最高）
         .header-year-input {
           width: 100% !important;
           height: 28px !important;
           line-height: 28px !important;
           padding: 0 8px !important;
           border: 1px solid #dcdfe6 !important;
           background-color: #fff !important;
           cursor: text !important;
           font-size: 14px;
           color: #606266;
           box-sizing: border-box;
           pointer-events: auto !important;
           position: relative;
           z-index: 10;
           
           &:focus {
             border-color: #409eff !important;
             outline: none;
           }
           
           &:hover {
             border-color: #c0c4cc !important;
           }
           
           &::placeholder {
             color: #c0c4cc;
           }
         }
         
         // 兼容el-input（如果还有使用）
         .el-input {
           width: 100%;
           pointer-events: auto !important;
           position: relative;
           z-index: 10;
           
           .el-input__inner {
             height: 28px !important;
             line-height: 28px !important;
             padding: 0 8px !important;
             border: 1px solid #dcdfe6 !important;
             background-color: #fff !important;
             cursor: text !important;
             pointer-events: auto !important;
             
             &:focus {
               border-color: #409eff !important;
               outline: none;
             }
             
             &:hover {
               border-color: #c0c4cc !important;
             }
           }
         }
       }
       
       // 表格内容区域的输入框样式
       .el-table__body-wrapper {
         .el-table__body {
           td {
             padding: 8px 0;
           }
         }
         
         .el-input {
           .el-input__inner {
             border: none;
             padding: 0;
             height: 32px;
             line-height: 32px;
           }
         }
       }
       
               // 表格内选择框样式
        .el-select {
          .el-input__inner {
            height: 32px;
            line-height: 32px;
          }
        }
        
        // 表格内按钮样式
        .el-button--text {
          color: #409eff;
          padding: 0 8px;
          font-size: 12px;
          
          &:hover {
            color: #337ecc;
            background: transparent;
          }
          
          &.el-button--text.el-button--danger {
            color: #f56c6c;
            
            &:hover {
              color: #f78989;
            }
          }
        }
        
        // 表格内输入框后缀样式
        .el-input-group__append {
          background-color: transparent !important;
          border: none !important;
          color: #333;
          padding: 0 8px;
        }
      }
  }

  .buttons {
    width: 100%;
    border-top: 1px solid #e5e6eb;
    padding-top: 32px;
    .el-button {
      padding: 12px 72px;
    }
  }
}

.minH {
  min-height: calc(100vh - 200px);
}
</style> 